import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { environment } from "../../../environments/environment";

/**
 * 🔹 VIEW (lo que recibes del backend)
 */
export interface EstadoConductor {
  id?: number; // opcional en creación
  descripcion: string;
  estado?: number; // opcional en creación
  fechaCreacion?: string; // lo devuelve el backend
  fechaModificacion?: string | null; // lo devuelve el backend
}

@Injectable({
  providedIn: "root",
})
export class EstadoConductorService {
  private apiUrl = `${environment.apiUrl}/api/estado-conductor`;

  constructor(private http: HttpClient) {}

  // Obtener todos
  getEstados(): Observable<EstadoConductor[]> {
    return this.http
      .get<EstadoConductor[]>(this.apiUrl, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  // Obtener activos
  getEstadosActivos(): Observable<EstadoConductor[]> {
    return this.http
      .get<EstadoConductor[]>(`${this.apiUrl}/activos`, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  // Obtener por ID
  getEstadoById(id: string | number): Observable<EstadoConductor> {
    return this.http
      .get<EstadoConductor>(`${this.apiUrl}/${id}`, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  // Crear
  createEstado(payload: EstadoConductor): Observable<EstadoConductor> {
    return this.http
      .post<EstadoConductor>(this.apiUrl, payload, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  // Actualizar
  updateEstado(id: string | number, payload: EstadoConductor): Observable<EstadoConductor> {
    return this.http
      .put<EstadoConductor>(`${this.apiUrl}/${id}`, payload, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  // Eliminar
  deleteEstado(id: string | number): Observable<any> {
    return this.http
      .delete<any>(`${this.apiUrl}/${id}`, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  // Activar
  activar(id: string | number): Observable<any> {
    return this.http
      .put<any>(`${this.apiUrl}/${id}/activar`, {}, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  // Inactivar
  inactivar(id: string | number): Observable<any> {
    return this.http
      .put<any>(`${this.apiUrl}/${id}/inactivar`, {}, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }
}
